// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getSecciones as listSeccionesAPI,
    getSeccion as getSeccionAPI,
    addSeccion as addSeccionAPI,
    updateSeccion as updateSeccionAPI,
    deleteSeccion as deleteSeccionAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { seccionesApiResponseError, seccionesApiResponseSuccess } from './actions';
import { SeccionesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getSeccion({ payload: { id } }) {
    try {
        const response = yield call(getSeccionAPI, id );
        const seccionItem = response.data.data;
        yield put(seccionesApiResponseSuccess(SeccionesActionTypes.GET_SECCION, seccionItem));
    } catch (error) {
        yield put(seccionesApiResponseError(SeccionesActionTypes.GET_SECCION, error));
    }
}

function* addSeccion({payload:seccion}){
    try{
        const response = yield call(addSeccionAPI,{...seccion})
        const seccionItem = response.data
        yield put(seccionesApiResponseSuccess(SeccionesActionTypes.ADD_SECCION,seccionItem))
    } catch(error){
        yield put(seccionesApiResponseError(SeccionesActionTypes.ADD_SECCION,error))
    }
}

function* updateSeccion({payload:seccion}){
    try{
        const response = yield call(updateSeccionAPI,{...seccion})
        const seccionItem = response.data.data
        yield put(seccionesApiResponseSuccess(SeccionesActionTypes.UPDATE_SECCION,seccionItem))
    }catch(error){
        yield put(seccionesApiResponseError(SeccionesActionTypes.UPDATE_SECCION,error))
    }
}
function* deleteSeccion({payload:{id}}){
    try{
        const response = yield call(deleteSeccionAPI,id)
        const seccionItem = response.data.id
        yield put(seccionesApiResponseSuccess(SeccionesActionTypes.DELETE_SECCION,seccionItem))
    }catch(error){
        yield put(seccionesApiResponseError(SeccionesActionTypes.DELETE_SECCION,error))
    }
}

/**
 * List contactos
 */
function* listSecciones({payload:params}) {
    try {
        const response = yield call(listSeccionesAPI, { ...params });
        const listaSecciones = response.data.data;
        yield put(seccionesApiResponseSuccess(SeccionesActionTypes.LIST_SECCIONES, listaSecciones));
    } catch (error) {
        yield put(seccionesApiResponseError(SeccionesActionTypes.LIST_SECCIONES, error));
    }
}


export function* watchGetSeccion(): any {
    yield takeEvery(SeccionesActionTypes.GET_SECCION, getSeccion);
}

export function* watchListSecciones(): any {
    yield takeEvery(SeccionesActionTypes.LIST_SECCIONES, listSecciones);
}

export function* watchAddSeccion():any{
    yield takeEvery(SeccionesActionTypes.ADD_SECCION,addSeccion)
}
export function* watchUpdateSeccion():any{
    yield takeEvery(SeccionesActionTypes.UPDATE_SECCION,updateSeccion)
}
export function* watchDeleteSeccion():any{
    yield takeEvery(SeccionesActionTypes.DELETE_SECCION,deleteSeccion)
}


function* seccionesSaga(): any {
    yield all([
        fork(watchGetSeccion),
        fork(watchListSecciones),
        fork(watchAddSeccion),
        fork(watchUpdateSeccion),
        fork(watchDeleteSeccion),
    ]);
}

export default seccionesSaga;
